import { WidgetTypes } from "@swiggy-private/dls-react-mxn/dist/WidgetController/constants";
import type { IPLWidgetControllerCards } from "@swiggy-private/dls-react-mxn/dist/WidgetController/PLWidgetController/type";
import { hasType } from "../Menu";
import { BOTTOM_WIDGET_HEIGHT } from "./constant";

interface CtaListCard {
    nudges?: unknown[];
}

export const getBottomWidgetHeight = (cards?: IPLWidgetControllerCards[] | null): number => {
    if (!cards?.length) return BOTTOM_WIDGET_HEIGHT.BASE;

    const ctaCard = cards.find(
        (card) => hasType(card) && card?.card?.card?.["@type"] === WidgetTypes.CTA_LIST
    );

    if (!ctaCard) return BOTTOM_WIDGET_HEIGHT.BASE;

    const nudgeCount = ((ctaCard.card.card as CtaListCard)?.nudges ?? []).length;
    if (nudgeCount <= 1) return BOTTOM_WIDGET_HEIGHT.BASE;

    return BOTTOM_WIDGET_HEIGHT.BASE + (nudgeCount - 1) * BOTTOM_WIDGET_HEIGHT.PER_NUDGE;
};
